import type { IconProps } from '../types/IconProps.ts';
export const LayoutPanelTop: IconProps = {
    name: 'LayoutPanelTop',
    children: [
        `<path d="M9 14H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1M20 14h-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1" />`,
        `<rect width="18" height="7" x="3" y="3" rx="1" />`,
    ]
};